import { Component, effect, ChangeDetectorRef } from '@angular/core';
import { InvoiceService } from './invoices.service';
import { LoginService } from '../login/login.service';
import { AdministrationService } from '../administration/administration.service';
import jwt_decode from 'jwt-decode';
import { JwtService } from '../../shared/services/jwt/jwt.service';

@Component({
    selector: 'app-invoices',
    templateUrl: './invoices.component.html',
    styleUrl: './invoices.component.sass',
    standalone: false
})

export class InvoicesComponent {
  
  displayedColumns: string[] = [
    'invoiceNumber',
    'invoiceDate',
    'offerType',
    'offerName',
    'totalAmount',
    'actualAmount',
    'taxRate',
    'paymentStatus',
    'orderCode',
    'invoiceFile'
  ];
  showInvoice = true;
  displayUsers = false;
  resp: any = {};
  userId = 0;
  subResponse: any[] = [];
  userMail = '';
  subsLoading = false;
  userType = '';
  noData = false;
  solidoNumber: any;
  secUserList: any[] = [];
  selectedUser: string | null = null;
  readonly defaultVariant = 'ADMIN';
  selectedVariant = this.defaultVariant;
  variantList = [{ code: 'ADMIN', label: 'ADMIN_INVOICES' },
                 { code: 'USERS', label: 'USERS_INVOICES' }];

  readonly paymentStatusClasses: Record<string, string> = {
    authorised: '!bg-[#fffaf2] !rounded-full border border-[--dsr-color-warning] !text-[--dsr-color-on-warning-container] !p-[5px]',
    captured: '!bg-[#f7fbff] !rounded-full border border-[--dsr-color-electric] !text-[--dsr-color-on-electric-container] !p-[5px]',
    settled: '!bg-[#f0f7f0] !rounded-full border border-[--dsr-color-success] !text-[--dsr-color-on-success-container] !p-[5px]',
    declined: '!bg-[#faf4f2] !rounded-full border border-[--dsr-color-error] !text-[--dsr-color-on-error-container] !p-[5px]' 
  };

  constructor(private invoiceService: InvoiceService, private loginService: LoginService,
              private jwtService: JwtService, private cdr: ChangeDetectorRef,
              private adminService: AdministrationService) {
    effect(() => {
      this.resp = this.loginService.gigyaResponse;          
      if(this.resp) {
        this.userId = this.resp.userId;
        this.userMail = this.resp.userMail;
        this.userType = this.resp.accessIdentifier;
        this.solidoNumber = this.resp.solidoNo;
        if(this.isVariantToggleDisabled()) {
          this.setSelectedVariant(this.defaultVariant);
        }
        this.getInvoices(this.userMail);
        this.getSecondaryUsers(this.solidoNumber);
        this.cdr.detectChanges();
      }
    });
  }
  getInvoices(userMail: string) {
    this.subsLoading = true;
    let userInfo = { "userMail": userMail };
    let userData: string = this.jwtService.encode(userInfo, "secret");
    this.invoiceService.getInvoiceDetails(userData).subscribe((response: any) => {
        this.subsLoading = false;
        this.noData = false;
        let encryptData = response;
        let invoiceData: any = jwt_decode(encryptData);
        const filteredInvoices = invoiceData.userInvoiceDetails.filter((element: any) => element.invoiceNumber != null);
        filteredInvoices.forEach((element: any) => {
          let text = element.invoiceNumber.substr(6, 16);
          let result = text.startsWith("0");
          if(result == false) {
            element.invoiceNumber = null;
          }
        });
        // reassign (not mutate) so the mat-table dataSource reference change is detected
        this.subResponse = filteredInvoices;
        if(this.subResponse.length === 0) {
          this.noData = true;
        }
        this.cdr.detectChanges();
      }, (error: any) => {
        this.subsLoading = false;
        this.noData = true;
        this.cdr.detectChanges();
    });
  }
  getPaymentStatusClass(paymentStatus: string | null | undefined): string {
    const normalizedStatus = (paymentStatus ?? '').toLowerCase();
    return this.paymentStatusClasses[normalizedStatus] || '';
  }
  isVariantToggleDisabled() {
    return this.userType !== 'INDADMIN';
  }
  setSelectedVariant(variantCode: string) {
    this.selectedVariant = variantCode;
    if(this.selectedVariant === 'ADMIN') {
      this.showInvoice = true;
      this.selectedUser = null;
      this.displayUsers = false;
      this.subResponse = [];
      this.getInvoices(this.userMail);
    } else {
      this.showInvoice = false;
      this.displayUsers = true;
    }
  }
  changeSelectedVariant(event: any) {
    if(this.isVariantToggleDisabled()) {
      this.setSelectedVariant(this.defaultVariant);
      return;
    }
    this.setSelectedVariant(event.value);
  }
  changeSelectedUser() {
    if(this.selectedUser) {
      this.subResponse = [];
      this.getInvoices(this.selectedUser);
    }
    this.showInvoice = true;
  }
  getSecondaryUsers(solido: any) {
    let userInfo = { solidoNumber: solido };
    let userData: string = this.jwtService.encode(userInfo, 'secret');
    this.adminService.getExistingUsers(userData).subscribe((response: any) => {
      let encryptData = response;
      let orgUsersData: any = jwt_decode(encryptData);
      this.secUserList = orgUsersData.orgUsers.responseDtos.filter((user: any) => !user.disabled);
    });
  }
}